module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_9.3e64c0b1.jpg";